import { useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom';
import styles from './AsinNotFoundModal.module.css';

const AsinNotFoundModal = ({ isOpen, notFoundAsins, onExcludeAndContinue, onContinueWithAll, onClose }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleCreateNewListing = () => {
        onClose();
        navigate('/single-listing-generator');
    };

    return ReactDOM.createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onClose}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="#505050"/>
                    </svg>
                </button>

                <div className={styles.documentIcon}>
                    <svg width="359" height="337" viewBox="0 0 359 337" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_bulk_nf)">
                        <g clipPath="url(#clip0_bulk_nf)">
                        <rect x="98.7043" y="73.4229" width="125.444" height="169.077" rx="10.9082" transform="rotate(-13.1732 98.7043 73.4229)" fill="white"/>
                        <rect x="108.534" y="79.5244" width="109.082" height="76.3574" rx="5.4541" transform="rotate(-13.1732 108.534 79.5244)" fill="#E5EDF3"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M158.788 77.0051L169.404 74.5211C171.477 74.036 173.493 75.4657 173.747 77.6064L177.307 107.432C177.524 109.256 176.364 110.926 174.599 111.339L170.56 112.284C168.796 112.697 167.019 111.718 166.403 109.995L156.271 81.7071C155.538 79.6785 156.712 77.4909 158.788 77.0051ZM174.065 118.367C177.853 117.481 181.648 119.867 182.544 123.698C183.441 127.529 181.099 131.351 177.311 132.238C173.523 133.124 169.728 130.738 168.832 126.907C167.936 123.079 170.278 119.254 174.065 118.367Z" fill="white"/>
                        <rect x="129.043" y="167.149" width="109.082" height="4.73346" rx="2.36673" transform="rotate(-13.1732 129.043 167.149)" fill="#E5EDF3"/>
                        <rect x="132.13" y="180.34" width="70.9491" height="4.73346" rx="2.36673" transform="rotate(-13.1732 132.13 180.34)" fill="#E5EDF3"/>
                        <rect x="135.218" y="193.531" width="97.9471" height="4.73346" rx="2.36673" transform="rotate(-13.1732 135.218 193.531)" fill="#E5EDF3"/>
                        </g>
                        <rect x="99.1139" y="73.6771" width="124.763" height="168.395" rx="10.5673" transform="rotate(-13.1732 99.1139 73.6771)" stroke="#D0E7FF" strokeWidth="0.681762"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_bulk_nf" x="-2.19647" y="-56.0659" width="362.477" height="395.017" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="9.54467" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_bulk_nf"/>
                        <feOffset/>
                        <feGaussianBlur stdDeviation="45.6781"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.470588 0 0 0 0 0.701961 0 0 0 0 0.952941 0 0 0 0.08 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_bulk_nf"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_bulk_nf" result="shape"/>
                        </filter>
                        <clipPath id="clip0_bulk_nf">
                        <rect x="98.7043" y="73.4229" width="125.444" height="169.077" rx="10.9082" transform="rotate(-13.1732 98.7043 73.4229)" fill="white"/>
                        </clipPath>
                        </defs>
                    </svg>
                </div>

                <div className={styles.content}>
                    <div className={styles.heading}>Oops...</div>
                    <div className={styles.message}>
                        The ASIN(s) <strong style={{fontSize:'16px'}}>{notFoundAsins.join(', ')}</strong>
                        <br />entered does not exist in your Product Catalogue
                    </div>
                    <div className={styles.buttonGroup}>
                        <button
                            type="button"
                            className={styles.outlineButton}
                            onClick={handleCreateNewListing}
                        >
                            Create New Listing
                        </button>
                        <button
                            type="button"
                            className={styles.outlineButton}
                            onClick={onExcludeAndContinue}
                        >
                            Exclude and Continue
                        </button>
                        {/* <button
                            type="button"
                            className={styles.primaryButton}
                            onClick={onContinueWithAll}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.6231 12.0277C9.8063 10.94 9.06019 10.1939 7.97248 5.37694C7.92265 5.15677 7.72669 5 7.50024 5C7.2738 5 7.07784 5.15677 7.028 5.37694C5.93981 10.1939 5.19419 10.94 0.377407 12.0277C0.156769 12.0781 0 12.2735 0 12.5C0 12.7265 0.156769 12.9219 0.377407 12.9723C5.19419 14.0605 5.93981 14.8066 7.028 19.6231C7.07784 19.8432 7.2738 20 7.50024 20C7.72669 20 7.92265 19.8432 7.97248 19.6231C9.06068 14.8066 9.8063 14.0605 14.6231 12.9723C14.8437 12.9219 15 12.7265 15 12.5C15 12.2735 14.8432 12.0781 14.6231 12.0277Z" fill="white"/>
                            <path d="M19.6207 3.89949C17.0437 3.31759 16.6819 2.95578 16.1 0.379334C16.0494 0.157285 15.8526 0 15.6248 0C15.3969 0 15.2001 0.157285 15.1495 0.379334C14.5676 2.95578 14.2058 3.31759 11.6293 3.89949C11.4073 3.95014 11.25 4.14686 11.25 4.37476C11.25 4.60265 11.4073 4.79938 11.6293 4.85002C14.2058 5.43192 14.5676 5.79373 15.1495 8.37067C15.2001 8.59223 15.3969 8.75 15.6248 8.75C15.8526 8.75 16.0494 8.59223 16.1 8.37067C16.6819 5.79373 17.0437 5.43192 19.6207 4.85002C19.8422 4.79938 20 4.60265 20 4.37476C20 4.14686 19.8422 3.95014 19.6207 3.89949Z" fill="white"/>
                            </svg>
                            Continue with All
                        </button> */}
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default AsinNotFoundModal;
